import React from "react";
import { Menu, Dropdown, Button } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";

const Menus = ({ listMenu }) => {
	return (
		<Menu>
			{listMenu.map((m, i) => (
				<Menu.Item key={i} onClick={m.onClick}>
					{m.label}
				</Menu.Item>
			))}
		</Menu>
	);
};

const EllipsisDropdownMenu = ({ listMenu }) => (
	<Dropdown
		key="more"
		overlayClassName="ant-missing-dropdown-menu-style"
		overlay={<Menus listMenu={listMenu} />}
	>
		<Button
			style={{
				border: "none",
				padding: 0,
				backgroundColor: "transparent",
			}}
		>
			<EllipsisOutlined
				style={{
					fontSize: 20,
					verticalAlign: "top",
				}}
			/>
		</Button>
	</Dropdown>
);

export default EllipsisDropdownMenu;
